import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || JSON.stringify(d);
}

export const digits = (s) => (s?.includes("JPY") ? 3 : s && /^[A-Z]{6}$/.test(s) && s !== "XAUUSD" ? 5 : 2);
export const fmtPrice = (v, s) => (v == null ? "—" : Number(v).toFixed(digits(s)));
const safeLocale = (value, locale, options) => {
  try { return value.toLocaleString(locale, options); }
  catch { return value.toLocaleString(undefined, options); }
};
export const fmtMoney = (v) =>
  v == null || !Number.isFinite(Number(v)) ? "—" : `${v < 0 ? "-" : ""}$${safeLocale(Math.abs(Number(v)), "en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "—" : safeLocale(d, "en-GB", { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
};
export const fmtDur = (s) => (s == null ? "—" : s < 120 ? `${Math.round(s)}s` : s < 7200 ? `${Math.round(s / 60)}m` : s < 172800 ? `${(s / 3600).toFixed(1)}h` : `${Math.round(s / 86400)}d`);
